export const formTsAgreementWithdrawFields = {
  EFFECTIVE_DATE: 'effectiveDate',
  REASON: 'reason',
  VIOLATION: 'violation',
};
